import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/AnneMarie/subs.vtt';
import poster from '@/static/assets/reviews/AnneMarie/video.jpg';

export const AnneMarie: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Anne',
  videoUrl: `${ASSETS_URL}/car/AnneMarie.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
